import { reatomAsync } from "@reatom/async";
import { PaymentSubscribeRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { trackError, trackEvent } from "src/util/analytics";

interface SubscribeCheckoutParams {
  data: PaymentSubscribeRequestDto;
  rateName?: string;
}

export const subscribeCheckoutAction = reatomAsync(
  async (_ctx, { data, rateName = "custom" }: SubscribeCheckoutParams) => {
    trackEvent("rate_checkout_started", { rate: rateName });

    const paymentWindow = window.open("", "_blank");
    if (!paymentWindow) {
      alert("Всплывающее окно было заблокировано вашим браузером.");
      trackError("payment_window_blocked");
      return;
    }

    await API.paymentApi
      .paymentControllerPaymentSubscribe(data)
      .then((response) => {
        paymentWindow.location.href = response.data.link;
      })
      .catch((error) => {
        trackError("subscribe_order_failed", {
          errorMessage:
            error instanceof Error ? error.message : "Unknown error",
        });
        paymentWindow.close();
      });
  },
  "subscribeCheckout",
).pipe(withIsLoadingAtom());
